// extracted by mini-css-extract-plugin
export default {"boxWithTitle":"styles_boxWithTitle__4dRWw","titleText":"styles_titleText__zX1AV","buttonsContainer":"styles_buttonsContainer__o2Q1W"};